import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.343 4.343A8 8 0 0 1 20 10c0 3.098-2.016 6.104-4.226 8.437A29.4 29.4 0 0 1 12 21.773a29.419 29.419 0 0 1-3.774-3.335C6.016 16.103 4 13.097 4 10a8 8 0 0 1 2.343-5.657m5.102 19.489L12 23l.555.832a1 1 0 0 1-1.11 0m0 0L12 23c.555.832.556.831.556.831l.002-.001.007-.005.023-.015.082-.057q.109-.074.302-.214a31.433 31.433 0 0 0 4.254-3.727C19.516 17.397 22 13.903 22 10a10 10 0 0 0-20 0c0 3.902 2.484 7.396 4.774 9.813a31.4 31.4 0 0 0 4.254 3.726 19 19 0 0 0 .384.27l.023.016.007.005zM10 10a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }